<section *ngIf="loading" class="container">
  <div class="no-service-container">
    <div class="no-service">Loading...</div>
  </div>
</section>
<section class="container" *ngIf="!loading && !noService">
  <app-connection-header [status]="connectionStatus"></app-connection-header>
  <app-trafik-left *ngIf="service && +service.remainingInGB() < 10"></app-trafik-left>
  <div class="firstRow">
    <a class="server-link">
      <app-server-link [serverCount]="servers.length" [serverName]="currentServer?.name || ''"
        [showServers]="showServers.bind(this)"></app-server-link>
    </a>
    <app-toggler [mode]="mode" [changeMode]="changeMode.bind(this)"></app-toggler>
  </div>
  <div class="trafik-panel-container">
    <app-trafik-panel [remainingTraffic]="service.remainingInGB() + ' GB'"
      [totalTraffic]="service.usageCapInGB() + ' GB'">
    </app-trafik-panel>
  </div>
</section>
<section *ngIf="!loading && noService" class="container">
  <div class="no-service-container">
    <div class="no-service">{{ "Home.NoService" | translate }}</div>
    <a class="buy-button" routerLink="/subscription">
      <app-button class="buy-button" [text]="'Home.Buy' | translate"></app-button>
    </a>
  </div>
</section>